import * as Mod1 from "./discourse/initializers/openid-connect-admin-plugin-configuration-nav";
const compatModules = {
  "discourse/initializers/openid-connect-admin-plugin-configuration-nav": Mod1,
};
export { compatModules };
export default compatModules;
